import Nav from './Nav';
import DirectoryApp from './DirectoryApp';
import BackgroundImages from './BackgroundImages';
import Snippets from './Snippets';
import ScrollObserver from './ScrollObserver';
import IntroSequence from './IntroSequence';
import ConnectionsBackground from './ConnectionsBackground';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import AlphabeticalNav from './AlphabeticalNav';

export default class MusicConnectionsApp {
    constructor() {
        console.log('Welcome to Music Connections');

        // Navigation & Newsletter trigger 
        new Nav();
        new Snippets();
        new ScrollObserver();
        
        this.bgImages = new BackgroundImages();

        const { isHome, showIntro } = window.AppData;

        // For scrolling window later
        gsap.registerPlugin(ScrollToPlugin);

        if (isHome) {
            if (showIntro) {
                new IntroSequence(() => this.onIntroComplete({ scrollDown: true }));
            } else {
                this.onIntroComplete({ scrollDown: false });
            }
        } else {
            if (document.body.classList.contains('has-background-image')) {
                this.onIntroComplete({ scrollDown: false });
            } else {
                new ConnectionsBackground();
            }
        }

        const searchElement = document.querySelector('.search');
        
        if (searchElement) {
            new DirectoryApp(searchElement);
        }

        const alphabeticalNav = document.querySelector('.alphabetical-nav');
        
        if (alphabeticalNav) {
            new AlphabeticalNav(alphabeticalNav);
        }
    }

    onIntroComplete({ scrollDown = true }) {
        this.bgImages.init();

        if (scrollDown) {
            
            // Watch for clicks on this
            const scrollDownBtn = document.querySelector('#scroll-down');
            scrollDownBtn.addEventListener('click', () => this.scrollIntoPlace(window.innerHeight), true);

            setTimeout(() => {
                if (window.pageYOffset === 0) {
                    this.scrollIntoPlace();
                }
            }, 2500);
        }

        this.removeScrollDownBtn = this.removeScrollDownBtn.bind(this);
    }

    scrollIntoPlace(targetY) {
        // Show the whole first unit in the page
        const firstBlock = document.querySelector('.page-content').firstElementChild;
        const rect = firstBlock.getBoundingClientRect();

        const paddingTop = window.getComputedStyle(document.body).getPropertyValue('padding-top');
        const paddingValue = Number(paddingTop.replace('px', ''));

        const marginBottom = window.getComputedStyle(firstBlock).getPropertyValue('margin-bottom');
        const marginValue = Number(marginBottom.replace('px', ''));

        const scrollTo = targetY || (rect.height + paddingValue + marginValue);

        gsap.to(window, { duration: 1, scrollTo, ease: 'power2.inOut', onComplete: () => {
            setTimeout(() => {
                if (targetY) {
                    this.removeScrollDownBtn();
                } else {
                    document.body.classList.add('show-scroll-down');
                    window.addEventListener('scroll', this.removeScrollDownBtn);
                }
            }, 1100);
        } });
    }

    removeScrollDownBtn() {
        const scrollDownBtn = document.querySelector('#scroll-down');

        if (scrollDownBtn) {
            scrollDownBtn.remove();
            window.removeEventListener('scroll', this.removeScrollDownBtn);
        }
    }
}